<template>
  <div class="hotels">
    <toolbar
      backRoute="/dashboard"
      title="Hotels"
      :addButton="true"
      addButtonLabel="Add hotel"
      addButtonRoute="/dashboard/hotels/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search hotels"
          @keyup.native.enter="saveFilters" />
        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="hotels" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="phone" view="hotels" :column="orderColumn" :direction="orderDirection">Phone number</sortable-table-heading>
          <sortable-table-heading field="email" view="hotels" :column="orderColumn" :direction="orderDirection">Email</sortable-table-heading>
          <th>Notes</th>
          <sortable-table-heading field="town" view="hotels" :column="orderColumn" :direction="orderDirection">Town</sortable-table-heading>
          <sortable-table-heading field="country_name" view="hotels" :column="orderColumn" :direction="orderDirection">Country</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="7"
            class="text-center">
            Loading hotels&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && hotels.length === 0">
            <td
              colspan="7"
              class="text-center">
              There are no hotels to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(hotel, index) of hotels"
          :key="'hotel-' + index">
          <td class="align-middle" style="width: 200px;">{{ hotel.name }}</td>
          <td class="align-middle" style="width: 180px;"><a :href="'tel:' + hotel.phone"><small>{{ hotel.phone }}</small></a></td>
          <td class="align-middle" style="width: 160px;"><a :href="'mailto:' + hotel.email"><small>{{ hotel.email }}</small></a></td>
          <td class="align-middle"><small>{{ hotel.notes }}</small></td>
          <td class="align-middle" style="width: 160px;">{{ hotel.town }}</td>
          <td class="align-middle" style="width: 140px;">{{ getCountry(hotel.country_id) }}</td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/hotels/' + hotel.id)"
              class="mr-2"
              title="Edit hotel">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeHotel(hotel.id)"
              title="Remove hotel">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import CommonGetters from './../utils/CommonGetters.js';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'hotels',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedCountries;
    }
  },
  data () {
    return {
      loaded: false,
      hotels: null,
      loadError: false,
      removeInProgress: false,
      countries: [],
      loadedCountries: false
    };
  },
  mounted () {
    this.loadFilteredData();
    this.loadAdditionalData();
  },
  methods: {
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/items',
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError',
        params: {
          pagination: 0
        }
      });
    },
    removeHotel (hotelID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/hotels/delete/',
        id: hotelID,
        successTitle: 'Hotel removed',
        successText: 'The selected hotel has been removed',
        confirmTitle: 'Do you really want to remove this hotel?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    getCountry (countryID) {
      return CommonGetters.getCountryById(countryID, this.countries);
    }
  }
};
</script>

<style lang="scss">

</style>
